import React from "react";
import MainAppGenericModal from "../GenericModal";

import styles from "./Modals.TwoOptionModal.module.scss";

export class TwoOptionModal extends React.Component {
  render() {
    const {
      open,
      title,
      subtitle,
      closeLabel,
      confirmLabel,
      handleClose,
      handleConfirm,
      modalContent,
      confirmDisabled,
      closeable = false,
      handleCloseIcon = () => {}
    } = this.props;


    const content = (

      <div className={styles["two-option-modal-wrapper"]}>
        {closeable &&
        <div
            className={styles["icon-close-wrapper"]}
            onClick={handleCloseIcon}
            data-automation-id="search-cancel"
          >
            <i className={`icon-iconos_close2 ${styles["icon-close"]}`}></i>
          </div>
          }
        <div className={styles["two-option-modal-title"]}>{title}</div>
        <div className={styles["two-option-modal-text"]}>{subtitle}</div>

        {modalContent &&
          modalContent
        }
        <div className={styles["two-option-modal-buttons"]}>
          <div
            className={styles["two-option-modal-button"]}
            onClick={handleClose}
            data-automation-id="cancel"
          >
            {closeLabel}
          </div>
          <div
            className={`${styles["two-option-modal-button"]} ${styles["two-option-modal-button-confirm"]} ${confirmDisabled ? styles["disabled"] : ""}`}
            onClick={confirmDisabled ? () => {return true} : handleConfirm}
            data-automation-id="confirm"
          >
            {confirmLabel}
          </div>
        </div>
      </div>
    );
    return (
      <div className={styles["two-option-modal-container"]}>
        {open && (
          <MainAppGenericModal
            open={open}
            content={content}
          ></MainAppGenericModal>
        )}
      </div>
    );
  }
}

export default TwoOptionModal;
